// Classic › home: the home page's own copy (#1119). Section titles, Home /
// Away, TBD and the stream badge come from site-core and the labels layer.

const en = {
  /** The upcoming card's count badge. */
  nextCount: (n: number) => `Next ${n}`,
  liveBadge: 'LIVE',
  /** The results strip's eyebrow. */
  latest: 'Latest',
  scrollLeft: 'Scroll left',
  scrollRight: 'Scroll right',
  scrollGalleryLeft: 'Scroll gallery left',
  scrollGalleryRight: 'Scroll gallery right',
  noResults: 'No results yet',
  noSponsors: 'No sponsors configured',
  /** Stands in for a sponsor logo that failed to load. */
  logoPlaceholder: 'Logo',
  getTickets: 'Get Tickets',
  viewAll: 'View All',
  heroAlt: (leagueName: string) => `${leagueName} banner`,
  noTeams: 'No teams found',
}

export default en
